module.exports = require("../../canvg/index.js");


// WEBPACK FOOTER //
// canvg/index.js"